import PropTypes from 'prop-types'
import _ from 'lodash'
import createReactClass from 'create-react-class'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ValidationBox, Input } from 'legacy/libs/react-form-tools'
import Select from 'legacy/libs/components/select'

import { withGettext } from 'lib/gettext'

const DataSourceSelect = createReactClass({
  mixins: [SchemaBranchMixin],

  propTypes: {
    gettext: PropTypes.func.isRequired,
    dataSourcesList: PropTypes.arrayOf(PropTypes.object),
  },

  schema: {
    dataSource: null,
  },

  componentDidMount() {
    if (!this.state.dataSource) {
      this.cursors.dataSource.set(_.first(this.props.dataSourcesList))
    }
  },

  render() {
    const { gettext } = this.props
    const options = _.map(this.props.dataSourcesList, (dataSource) => ({
      label: dataSource.name,
      value: dataSource.pk,
    }))
    const { dataSource } = this.state
    const selectedDataSource =
      dataSource && dataSource.pk !== 0
        ? _.find(this.props.dataSourcesList, { pk: dataSource.pk })
        : { pk: 0, isExternal: true }

    return (
      <div className="grid gap-4 sm:grid-cols-2 sm:gap-6 md:gap-8">
        <div className="space-y-4">
          <ValidationBox fieldPath="dataSource.pk">
            <label className="mb-2 block text-default-light">
              {gettext('Data source')}
            </label>

            <Select options={options} style={{ width: '100%' }} />
          </ValidationBox>

          {selectedDataSource && selectedDataSource.isExternal && (
            <ValidationBox
              fieldPath="externalUrl"
              className="validationbox"
              errorMessageClassName="text-danger mt-1 text-xs"
            >
              <Input
                className="input"
                maxLength="140"
                placeholder={gettext('External URL')}
              />
            </ValidationBox>
          )}
        </div>

        <p className="text-xs text-default-light sm:pt-6">
          {gettext(
            'Change this option if the source of the data for your entry is an external project.'
          )}
        </p>
      </div>
    )
  },
})

export default withGettext(DataSourceSelect)
